/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { Calculator } from './calculator';

function AdorCash({
    attributes, operators, formulaUpdated, setFormulaUpdated, params, fetchedFormula, setChangesMade,
}) {
    // const [adorcashparams, setadorcashParams] = useState({
    //     redeem: '',
    //     avail: '',
    // });
    const [adorcashparams, setadorcashParams] = useState(fetchedFormula[params]);

    const InputChange = (e, index) => {
        setChangesMade(true);
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '' || parseFloat(value) >= 100 || parseFloat(value) <= 0) {
            adorcashparams[id] = '';
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            adorcashparams[id] = value;
            setadorcashParams((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
        formulaUpdated[params] = adorcashparams;
        setFormulaUpdated(formulaUpdated);
    };

    return (
        <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
            <p className="text-f3 font-normal text-[#090406] pb-5">Ador Cash (%)</p>
            {/* <Calculator attributes={attributes} operators={operators} formulaUpdated={formulaUpdated} setFormulaUpdated={setFormulaUpdated} params={params} /> */}
            <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
                <div className="flex items-center -mx-0.5">
                    <div className="px-0.5 w-[27%]">
                        <div className="relative w-full">
                            <input
                                type="number"
                                id="redeem"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                                autoComplete="off"
                                onKeyDown={(e) => {
                                    if (e.which === 38 || e.which === 40) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    InputChange(e);
                                }}
                                onWheel={(e) => e.target.blur()}
                                value={adorcashparams.redeem}

                            />
                            <label htmlFor="redeem" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                Ador Cash Redeemmed
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                        </div>
                    </div>
                    <div className="px-0.5 w-[27%]">
                        <div className="relative w-full">
                            <input
                                type="number"
                                id="avail"
                                className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                                autoComplete="off"
                                onKeyDown={(e) => {
                                    if (e.which === 38 || e.which === 40) {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    InputChange(e);
                                }}
                                onWheel={(e) => e.target.blur()}
                                value={adorcashparams.avail}
                            />
                            <label htmlFor="avail" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                                Ador Cash Avail
                                {' '}
                                <span className="text-[#ED1C24]">*</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdorCash;
